<script setup>
import { computed, onMounted } from "vue";
import store from "@/store";
import WalletActivity from "@/features/Wallet/WalletActivity.vue";
import KycFlow from "@/features/Wallet/KycFlow.vue";
import PayOnboarding from "@/features/Wallet/Onboarding/PayOnboarding.vue";

const user = computed(() => {
  return store.state.authentication?.user;
});

const payEnabled = computed(() => {
  return user?.value?.cloaked_card_enabled;
});

const kycValidated = computed(() => {
  return user.value?.cloaked_card_kyc_configured;
});

const onboardingCompleted = computed(() => {
  return user.value?.cloaked_card_post_kyc_onboarding_completed;
});

const showOnboarding = computed(() => {
  return payEnabled.value && kycValidated.value && !onboardingCompleted.value;
});

onMounted(() => {
  store.dispatch("authentication/getUser");
});
</script>

<template>
  <PayOnboarding v-if="showOnboarding" />
  <WalletActivity v-else-if="payEnabled && kycValidated" />
  <KycFlow v-else-if="payEnabled && !kycValidated" />
</template>
